import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-sm text-slate-500">
        Checking session…
      </div>
    );
  }
  if (!user) {
    if (role === "admin") return <Navigate to="/admin" replace />;
    if (role === "vendor") return <Navigate to="/vendor/login" replace />;
    return <Navigate to="/login" replace />;
  }
  // role can be a string or an array of allowed roles.
  const allowed = Array.isArray(role) ? role : role ? [role] : null;
  if (allowed && !allowed.includes(user.role)) {
    if (user.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    if (user.role === "vendor") return <Navigate to="/vendor" replace />;
    if (user.role === "read_only") return <Navigate to="/staff" replace />;
    return <Navigate to="/portal" replace />;
  }
  return children;
}
